import {PagingImpl} from "@variocube/app-ui";

export const deliveryPaging = new PagingImpl('delivery_paging');
export const shipmentPaging = new PagingImpl('shipment_paging');
export const recipientsPaging = new PagingImpl('recipients_paging');
export const usersPaging = new PagingImpl('users_paging');
